export default "__VITE_ASSET__CH_Uo9c3__"